<template>

  <div class="container">
    <div class="alert_text">

      <div class="row d-flex justify-content-center">
        <img class="logo" src="../assets/toggle.svg"/>
      </div>

      <div class="row d-flex justify-content-center pb-3 pl-1 pr-1">
        <p>We're currently cracking on with some scheduled maintenance</p>
      </div>

      <div class="row d-flex justify-content-center pl-1 pr-1">
        <h1>We'll be up and running again soon</h1>
      </div>

    </div>
  </div>
   
</template>

<script>
export default {
  name: 'Login',
  inject: ['$validator'],
  data : function(){       
      return {

      };
  },
  created:function(){

    
  },
  computed:{
   
  },
  methods:{

     

  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/scss/variables";


.alert_text{
  margin-top: calc(50vh - 96px);
  width:100%;
  display:block;
  text-align: center;
  .logo {
    width: 150px;
    margin-bottom: 20px;
  }
  p, a{
    text-align: center;
    color:white !important;
  }
  p, h1 {
    font-family: 'Open Sans', sans-serif;
    margin: 0;
  }
  h1 {
    font-size: 1.5625rem;
    font-weight: bold;
  }
  p{
    font-size: 1.0625rem;
    font-weight: 100;
    margin-bottom: 2px;
  }
}

</style>
